export default {"src":"/_next/static/media/tourismlogo4.953e8708.svg","height":50,"width":84,"blurWidth":0,"blurHeight":0};